// extracted by mini-css-extract-plugin
export default {"root":"PromotedBadge_root__ZfZty","label":"PromotedBadge_label__yyVvF","divider":"PromotedBadge_divider__+ZBr4","detail":"PromotedBadge_detail__XRj6C"};